import styled from 'styled-components';
import { ContainerSection } from '@/main/components/shared/styles';

export const Container = styled(ContainerSection)``;

export const RowSelect = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: flex-start;
  gap: 10px;
  overflow: hidden;

  @media (max-width: 426px) {
    grid-template-columns: 1fr;

    button {
      width: 100%;
      max-width: 100%;
      padding: 0.4rem 0 !important;
      margin: 0;
    }
  }
`;

export const AutoCompleteField = styled.div`
  overflow: hidden;
  `;

